module.exports = __webpack_public_path__ + "23f80adcacc0d6399caea6f27108db7f.pdf";